import { Component, OnInit } from "@angular/core";
import { MetadataService } from "../../metadata.service";
import { Author } from "../../models/author";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "app-leaderboard",
  templateUrl: "./leaderboard.component.html",
  styleUrls: ["./leaderboard.component.css"]
})
export class LeaderboardComponent implements OnInit {
  topRedditors: Observable<Author[]>;
  leaders: Author[];
  leaderTypeMap: any;
  leaderType: string;
  leaderUrl: string;
  leaderTitle: string;
  leaderTitleMap: any;
  start: string;
  days: string;
  timePeriod: string;
  isloading: boolean;
  leaderImageMap: any;

  constructor(private service: MetadataService) {}

  ngOnInit() {
    this.leaderTypeMap = new Map([
        [ "user", "author" ],
        [ 'domain', 'domain' ],
        [ "r", "subreddit_name" ]
    ]);
    this.leaderTitleMap = new Map([
        [ "user", "User" ],
        [ 'domain', 'Domain' ],
        [ "r", "Subreddit" ]
    ]);
    this.leaderType = 'author';
    this.leaderUrl = 'user';
    this.leaderTitle = 'User';
    this.timePeriod = "0";
    this.topRedditors = this.service.getTopRedditors();
    this.topRedditors.subscribe(authors => this.setupLeaderBoard(authors));
    this.isloading = false;
  }

  setupLeaderBoard(authors: Author[]) {
    this.leaders = authors;
    this.isloading = false;
  }

  public timeFilterClick(time: string){
    this.isloading = true;
    this.start = '2017-07-03';
    this.days = '0';
    this.timePeriod = time;
    let today = new Date();
    let year;

    switch(time) {
      case "1":
            year = today.getFullYear()-1;
            this.start = year.toString()+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+("0" + today.getDate()).slice(-2);
            this.days = '365';
            break;
      case "2":
            year = today.getFullYear();
            this.start = year.toString()+'-01-01';
            this.days = '365';
            break;
      case "3":
            today.setDate(today.getDate() - 30);
            this.start = today.getFullYear()+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+("0" + today.getDate()).slice(-2);
            this.days = '30';
            break;
      case "4":
            today.setDate(today.getDate() - 7);
            this.start = today.getFullYear()+'-'+("0" + (today.getMonth() + 1)).slice(-2)+'-'+today.getDate();
            this.days = '7';
            break;
    }
    if(time==="0"){
      this.topRedditors = this.service.getTopRedditors(this.leaderType,this.start);
    }else{
      this.topRedditors = this.service.getTopRedditors(this.leaderType,this.start,this.days);
    }
    this.topRedditors.subscribe(authors => this.setupLeaderBoard(authors));

  }

  public changeLeaderClick(leader: string){
    this.isloading = true;
    this.leaderUrl = leader;
    if(this.leaderTypeMap.has(leader)){
      this.leaderType = this.leaderTypeMap.get(leader);
      this.leaderTitle = this.leaderTitleMap.get(leader);
    }else{
      this.leaderType = 'author';
      this.leaderTitle = 'User';
    }
    this.topRedditors = this.service.getTopRedditors(this.leaderType,this.start,this.days);
    this.topRedditors.subscribe(authors => this.setupLeaderBoard(authors));

  }

  public getLeaderUrl(){
    return this.leaderUrl;
  }

  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/home/leaderboard/leaderboard.component.ts